import { defineComponent as _defineComponent } from 'vue'
interface Props {
  value?: string;
  placeholder: string;
  disabled?: boolean;
  type?: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'Input',
  props: {
    value: { default: '' },
    placeholder: { default: '' },
    disabled: { type: Boolean, default: false },
    type: { default: 'text' }
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as { value: string, placeholder: string, disabled: boolean, type: string }





function updateValue(event: any) {
  emit('input', event.target.value);
}

return { __sfc: true,props, emit, updateValue }
}

})